var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCartSm = function SvgCartSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#061e21",
    d: "M2 3.875a.625.625 0 0 1 .625-.625H4.5a.625.625 0 0 1 .606.474l.506 2.026h14.513a.625.625 0 0 1 .614.74l-1.875 10a.626.626 0 0 1-.614.51H7a.625.625 0 0 1-.614-.51L4.513 6.509l-.5-2.009H2.625A.625.625 0 0 1 2 3.875M5.878 7l1.64 8.75h10.213L19.372 7zM8.25 17a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M17 17a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m-8.75 1.25a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5m8.75 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5"
  })));
};
export default SvgCartSm;